module.exports = __webpack_public_path__ + "img/bn_vip.f799bc6c.png";